// extracted by mini-css-extract-plugin
export default {"cell":"CZKJ2f","content":"cVMszg","hasEvents":"H7A1P0","weekend":"_DOxj8","today":"vkuBaD","weekendToday":"nsd93p","dayNumber":"_mR1E_","otherMonth":"Fm4PrW","skeletonLine":"yeqMbr"};